import { render, staticRenderFns } from "./FormAgreement.vue?vue&type=template&id=6bf98408&scoped=true&"
import script from "./FormAgreement.vue?vue&type=script&lang=js&"
export * from "./FormAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf98408",
  null
  
)

export default component.exports